const ignore = ['favorite', 'memoid'];
export const clearLocalStorageOnLogout = () => {
  Object.keys(localStorage).forEach((key) => {

    if (key !== "react-use-cart"){
      !ignore.includes(key) ? localStorage.removeItem(key) : "";
    }
       

    }

  );
};
